// src/components/NotificationComponent.tsx

import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { NotificationService } from '../services/NotificationService';
import TokenManager from '../services/TokenManager';

interface NotificationComponentProps {
  onTokenReceived?: (token: string) => void;
}

interface ToastProps {
    id: string;
    title: string;
    body: string;
    onClose: () => void;
  }

  const NotificationToast: React.FC<ToastProps> = ({ 
    title, 
    body, 
    onClose 
  }) => (
    <div className="toast show" role="alert">
      <div className="toast-header">
        <strong className="me-auto">{title}</strong>
        <button 
          type="button" 
          className="btn-close" 
          onClick={onClose}
          aria-label="Close"
        />
      </div>
      <div className="toast-body">
        {body}
      </div>
    </div>
  );

const NotificationComponent: React.FC<NotificationComponentProps> = ({ 
  onTokenReceived 
}) => {
  const [permission, setPermission] = useState<NotificationPermission>('default');
  const [error, setError] = useState<string | null>(null);


useEffect(() => {
  const initializeNotifications = async () => {
    console.log('1. Starting notification initialization');
    try {
      const service = NotificationService.getInstance();
      console.log('2. Service instance created');
      
      // Add this line
      await service.initialize();
      console.log('3. Service initialized');
      
      const currentPermission = service.getCurrentPermission();
      console.log('4. Current permission:', currentPermission);

      if (currentPermission === 'default') {
        console.log('5. Requesting permission...');
        const newPermission = await service.requestPermission();
        console.log('6. New permission:', newPermission);
        setPermission(newPermission);
      }
    } catch (err) {
      console.error('Error in initializeNotifications:', err);
    }
  };

  initializeNotifications();
}, []);

  // Register custom toast renderer
  useEffect(() => {
    toast.custom((t: any) => {
      if (t.type === 'foreground') {
        return (
          <NotificationToast
            id={t.id}
            title={t.title}
            body={t.body}
            onClose={() => toast.dismiss(t.id)}
          />
        );
      }
      return null;
    });
  }, []);

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Failed to initialize notifications: {error}
      </div>
    );
  }

  if (permission === 'denied') {
    return (
      <div className="alert alert-warning" role="alert">
        Please enable notifications in your browser settings to receive updates.
      </div>
    );
  }

  return null;
};

export default NotificationComponent;